<template>
  <b-navbar toggleable="lg" type="dark" sticky>
    <div class="container">
      <b-navbar-brand :to="{ name: 'checkins-list'}">
        <div class="d-flex align-items-center position-relative">
          <transition name="slide-right" v-if="doAnimation">
            <div class="align-items-center nav-back" v-if="showBackButton">
              <Icon name="chevronLeft" width="34" class="mr-2"/>
              <span>{{ $t('pages.checkins_detail.back') }}</span>
            </div>
          </transition>

          <transition name="slide-left" v-if="doAnimation">
            <div class="logo" v-if="appConfigReady && !showBackButton">
              <img :src="getAppLogo" alt="Logo">
            </div>
          </transition>
        </div>
      </b-navbar-brand>

      <b-navbar-nav class="ml-auto py-0 d-flex align-items-center">
        <li class="nav-item"><ImpersonateBadge/></li>
        <li class="nav-item">
          <a class="nav-link nav-link--main d-flex align-items-center" href="#"
             @click.prevent="$bvModal.show('bv-modal-checkin-maker')">
            <Icon name="plusCircle" :width="30"/>
            <span class="d-none d-md-block ml-md-2 mr-md-1">{{ $t('menu.do_checkin') }}</span>
          </a>
        </li>
        <router-link tag="li" :to="{ name: 'checkout'}" v-if="showNavbarCart" custom
                     v-slot="{ href, navigate }">
          <li class="nav-item">
            <a class="nav-link nav__cart" :href="href" @click="navigate">
              <Icon name="cart" :height="18"/>
              <span class="ml-2 d-none d-md-block" v-if="getItemsTotalFormatted">{{ getItemsTotalFormatted }}</span>
            </a>
          </li>
        </router-link>
        <li class="nav-item">
          <b-dropdown right variant="link" :menu-class="'dropdown-custom__menu fade'"
                      toggle-class="" class="dropdown-custom dropdown-custom--main"
                      no-caret>
            <template #button-content>
              <div class="fries">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </template>
            <template v-for="(item, index) in menuItems">
              <router-link :to="{ name: item.route}" tag="b-dropdown-item" :key="index" v-if="item.route">
                <span class="d-flex justify-content-between">
                  <span>{{ $t(item.name) }}</span> <span v-if="item.extra" class="extra">{{ item.extra }}</span>
                </span>

              </router-link>
              <b-dropdown-divider v-if="item.divider" :key="index"></b-dropdown-divider>
              <b-dropdown-item href="#" @click.prevent="item.action" v-if="item.action" :key="index">
                {{ $t(item.name) }}
              </b-dropdown-item>
            </template>
            <template v-if="isPicaThirdLevelDomain">
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item :href="getB2BUrl()" target="_blank">
                GetPica Business
                <Icon name="linkExternal" width="16" class="ml-1"/>
              </b-dropdown-item>
              <div class="border-bottom-gradient"></div>
            </template>
          </b-dropdown>
        </li>
      </b-navbar-nav>

    </div>
  </b-navbar>
</template>


<script>
import ImpersonateBadge from "@/domain/impersonate/ImpersonateBadge.vue";
import {mapActions, mapGetters} from "vuex";
import {getB2BUrl} from "@/utils";

export default {
  components: {ImpersonateBadge},
  data() {
    return {
      doAnimation: false
    }
  },
  computed: {
    ...mapGetters(['isPicaThirdLevelDomain']),
    ...mapGetters('auth', [
      'currentUser'
    ]),
    ...mapGetters('appConfig', ['appConfigReady', 'getAppLogo', 'hideCart']),
    ...mapGetters('cart', ['getItemsTotalFormatted']),
    showNavbarCart() {
      return this.appConfigReady &&
          !this.hideCart &&
          this.$route.meta.showNavbarCart !== false
    },
    showBackButton() {
      return this.$route.meta.showBackButton
    },
    menuItems() {
      return [
        {name: 'menu.checkins_list', route: 'checkins-list'},
        {name: 'menu.do_checkin', action: () => this.$bvModal.show('bv-modal-checkin-maker')},
        {divider: true},
        {name: 'menu.account', route: 'profile-resume', extra: this.currentUser.email},
        {name: 'menu.privacy_settings', route: 'profile-privacy'},
        {name: 'menu.password_change', route: 'profile-change-password'},
        {name: 'menu.logout', action: () => this.onLogout()},
      ]
    }
  },
  mounted() {
    setTimeout(() => {
      this.doAnimation = true
    }, 1000)
  },

  methods: {
    getB2BUrl,
    ...mapActions('auth', ['logout']),

    async onLogout() {
      await this.logout()
      await this.$router.push('/')
    }
  }
}
</script>
